import React from "react";

const Menu = () => {
return(
    <>
           <a
            href="#"
            className="w-full block text-[#020220] text-lg font-semibold leading-10"
          >
            About
          </a>
          <a
            href="/programs"
            className="w-full block text-[#020220]  text-lg font-semibold leading-10"
          > 
            Program
          </a>
          <a
            href="#"
            className="w-full block text-[#020220]  text-lg font-semibold leading-10"
          >
            Service
          </a>
          <a  
            href="#"
            className="w-full block text-[#020220]  text-lg font-semibold leading-10 "
          >
            Contact
          </a>
            </>   
  );
};

export default Menu;
